import { render, staticRenderFns } from "./StripeDesign.vue?vue&type=template&id=535c9c35&scoped=true&"
import script from "./StripeDesign.vue?vue&type=script&lang=js&"
export * from "./StripeDesign.vue?vue&type=script&lang=js&"
import style0 from "./StripeDesign.vue?vue&type=style&index=0&id=535c9c35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535c9c35",
  null
  
)

export default component.exports